import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AiOutlineSelect } from 'react-icons/ai';
import { Flex, Heading, ProgressCircle } from '@adobe/react-spectrum';
import ProjectProgressBar from '../../components/ProjectProgressBar';
import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';
import OBJCODE from '../../constants';
import { Title, Container, TaskExternalLink } from './styles';
import daysLeft from '../../utils/daysLeft';
import { getLocalDateTime } from '../../utils/utils';

const Projects = props => {
  const [projects, setProjects] = useState({ isLoading: true, elements: [] });
  const [stackOfProjectsWithTasks, setStackOfProjectsWithTasks] = useState([]);
  const [error, setError] = useState(false);
  const [workfrontEndpoint, setWorkfrontEndpoint] = useState('');

  const { user, getParentId } = props;
  async function getProjects() {
    setProjects({ ...projects, isLoading: true });
    const fields = [
      'project:name',
      'project:plannedStartDate',
      'project:plannedCompletionDate',
      'project:percentComplete',
      'project:program',
      'project:portfolio',
      'percentComplete',
      'plannedStartDate',
      'plannedCompletionDate',
      'assignmentsListString',
      'assignments:assignedTo',
      'status',
      'taskNumber',
    ];
    const queryParams = {
      'assignments:assignedToID': user,
      parentID_Mod: 'notblank',
      'project:status': 'CUR',
      'OR:1:project:ownerID': user,
      'OR:1:parentID_Mod': 'notblank',
      'OR:1:project:status': 'CUR',
    };
    const actionResponse = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.TASK_SEARCH, queryParams, fields },
    );
    if (actionResponse.error) {
      setError(true);
      setProjects({
        ...projects,
        projectsList: [],
        isLoading: false,
      });
    } else {
      setProjects({
        ...projects,
        projectsList: actionResponse,
        isLoading: false,
      });
      setWorkfrontEndpoint(actionResponse[0].workfrontEndpoint);
    }
  }

  useEffect(() => {
    if (user.length > 0) {
      getProjects();
    }
  }, [user]);

  useEffect(() => {
    if (stackOfProjectsWithTasks.length > 0) {
      getParentId(stackOfProjectsWithTasks[0].ID);
    }
  }, [stackOfProjectsWithTasks]);

  const assertByProjects = tasks => {
    const sortedProjects = [];
    if (tasks) {
      tasks.forEach(task => {
        const currentProject = sortedProjects.find(
          p => p.name === task.project.name,
        );
        if (!currentProject) {
          const project = { ...task.project, tasks: [] };
          project.tasks.push(task);
          sortedProjects.push(project);
        } else {
          currentProject.tasks.push(task);
        }
      });
    }
    return sortedProjects;
  };

  useEffect(() => {
    const allTasksByProject = assertByProjects(projects.projectsList);
    setStackOfProjectsWithTasks(allTasksByProject);
  }, [projects]);

  return (
    <Container>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        marginX="size-300"
        marginBottom="size-115"
      >
        <Title>My Projects</Title>
        <TaskExternalLink>
          <AiOutlineSelect size={14} style={{ transform: 'scaleX(-1)' }} />
          <span>Take me to...</span>
        </TaskExternalLink>
      </Flex>
      {stackOfProjectsWithTasks.length ? (
        stackOfProjectsWithTasks.map((project, index) => (
          <div key={index}>
            <ProjectProgressBar
              id={project.ID}
              getParentId={getParentId}
              dueDate={project.plannedCompletionDate}
              completed={project.percentComplete.toFixed()}
              projectName={project.name}
              workfrontEndpoint={workfrontEndpoint}
              daysLeft={daysLeft(
                getLocalDateTime(project.plannedCompletionDate),
              )}
            />
          </div>
        ))
      ) : (
        <Flex justifyContent="center" marginY="size-1000">
          {error ? (
            <Heading marginStart="10px">No results</Heading>
          ) : (
            <ProgressCircle aria-label="Loading…" size="L" isIndeterminate />
          )}
        </Flex>
      )}
    </Container>
  );
};

Projects.propTypes = {
  user: PropTypes.string.isRequired,
};

export default Projects;
